import { createTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';

const theme = createTheme({
  palette: {
    primary: red,
  },
});

export default theme;
